export default {
  reviewsCount: {
    id: 'models_comparison_results_reviews_count',
    defaultMessage: '{count} reviews',
  },
  startingAt: {
    id: 'price_guide_highlight_cards_starting_at_price',
    defaultMessage: 'Starting at',
  },
  alreadySold: {
    id: 'already_sold',
    defaultMessage: 'Sold out',
  },
} as const
